import React from "react";

export const NAV_ITEMS = [
  { 
    key: "dashboard", 
    label: "Dashboard", 
    icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6", 
    path: "/user-dashboard" 
  },
  { 
    key: "loadboard", 
    label: "Load Board", 
    icon: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z", 
    badge: "Live", 
    path: "/load-board" 
  },
  { 
    key: "jobs", 
    label: "My Jobs", 
    icon: "M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z", 
    path: "/my-jobs" 
  },
  { 
    key: "saved-loads", 
    label: "Saved Loads", 
    icon: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z", 
    path: "/saved-loads" 
  },
  { 
    key: "invoice", 
    label: "Invoices", 
    icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z", 
    path: "/invoices" 
  },
  // { 
  //   key: "companies", 
  //   label: "Companies", 
  //   icon: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4", 
  //   path: "#/companies" 
  // },
  // { 
  //   key: "messages", 
  //   label: "Messages", 
  //   icon: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z", 
  //   badge: 2, 
  //   path: "#/messages" 
  // },
  { 
    key: "settings", 
    label: "Settings", 
    icon: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z", 
    path: "/settings" 
  },
];

export function Icon({ d, size = "w-5 h-5", stroke = 1.8 }) {
  if (typeof d !== 'string') return null;

  return (
    <svg className={`${size} flex-shrink-0`} fill="none" stroke="currentColor" strokeWidth={stroke} viewBox="0 0 24 24">
      {d.split(" M").map((seg, i) => (
        <path key={i} strokeLinecap="round" strokeLinejoin="round" d={i === 0 ? seg : "M" + seg} />
      ))}
    </svg>
  );
}